if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
     abortController = undefined;
pendingRequestUrl = null;
latestVariantRequest = 0;
preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      _variantChangeDispatched = false;

      constructor() {
        super();

        this.quantityInput = this.querySelector(".quantity__input");
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent("product-info:loaded", { bubbles: true })
        );
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll(".scroll-trigger")
            .forEach((element) =>
              element.classList.add("scroll-trigger--cancel")
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({
  data: { event, target, selectedOptionValues },
}) {
  if (!this.contains(event.target)) return;

  this.resetProductFormState();

  const variant = this.applySelectedVariantImmediately();

  const productUrl =
    target.dataset.productUrl ||
    this.pendingRequestUrl ||
    this.dataset.url;

  this.pendingRequestUrl = productUrl;

  // Oryndra MIA INP fix:
  // MIA variants share the same price/sell state, so do not fetch/re-render
  // the full product section on every colour/size tap.
  if (productUrl.includes("/products/mia-comfortabele-orthopedische-sneakers")) {
    if (variant?.id) {
      this.updateURL(productUrl, variant.id);
    }
    return;
  }

  const shouldSwapProduct = this.dataset.url !== productUrl;
  const shouldFetchFullPage =
    this.dataset.updateUrl === "true" && shouldSwapProduct;

  this.renderProductInfo({
    requestUrl: this.buildRequestUrlWithParams(
      productUrl,
      selectedOptionValues,
      shouldFetchFullPage
    ),
    targetId: target.id,
    callback: shouldSwapProduct
      ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
      : this.handleUpdateProductInfo(productUrl),
  });
}

      async updateQuantityBreakBlocks(html) {
        try {
          await new Promise((resolve) => setTimeout(resolve, 500));

          const response = await fetch(window.location.href);
          if (!response.ok) throw new Error('Network response was not ok');
          const text = await response.text();
          const newDocument = new DOMParser().parseFromString(
            text,
            "text/html"
          );

          const product = this.closest(".product");
          if (!product) return;

          const quantityBreaks = product.querySelectorAll(".lumin-product-block-qty-break");
          if (!quantityBreaks.length) return;

          quantityBreaks.forEach((elem) => {
            const newElement = html.querySelector(
              `#lumin-product-block-qty-break-${elem.dataset.blockId}`
            );
            if (newElement) {
              elem.replaceWith(newElement);
              // Reinitialize the new element
              if (window.LuminProductQtyBreak) {
                newElement.handleInputChange();
                newElement.handleOptionChange();
                newElement.handleAtc();
              }
            }
          });
        } catch (error) {
          console.error('Error updating quantity break blocks:', error);
        }
      }

      getSelectedVariantId(optionValues) {
        // Logic to derive the variant ID from selected option values
        // This could involve searching a variant map or similar
        return this.getSelectedVariant(this).id;
      }

      resetProductFormState() {
  const productForm = this.productForm;
  // Oryndra fix: do not disable Add to cart on size/colour click.
  // Facebook/Instagram in-app browser is slower, so disabling here caused first-click freeze.
  productForm?.handleErrorMessage();
}

getCurrentSelectedOptionNames() {
  const variantSelectors = this.variantSelectors;
  if (!variantSelectors) return [];

  return Array.from(variantSelectors.querySelectorAll("fieldset, select"))
    .map((optionGroup) => {
      if (optionGroup.tagName === "SELECT") return optionGroup.value;
      return optionGroup.querySelector('input[type="radio"]:checked')?.value;
    })
    .filter(Boolean);
}

getVariantsFromPageData() {
  const variantData =
    this.variantSelectors?.querySelector('script[data-product-variants]') ||
    document.querySelector('script[data-product-variants]');

  if (!variantData?.textContent?.trim()) return [];

  try {
    return JSON.parse(variantData.textContent);
  } catch (error) {
    console.error("Error parsing product variants JSON:", error);
    return [];
  }
}

getVariantFromCurrentOptions() {
  const selectedOptions = this.getCurrentSelectedOptionNames();
  if (!selectedOptions.length) return null;

  return this.getVariantsFromPageData().find((variant) => {
    const options =
      variant.options ||
      [variant.option1, variant.option2, variant.option3].filter(Boolean);

    return selectedOptions.every(
      (value, index) => String(options[index]) === String(value)
    );
  });
}

applySelectedVariantImmediately() {
  const variant = this.getVariantFromCurrentOptions();
  if (!variant) return;

  this.updateVariantInputs(variant.id);
  this.updateMediaFromVariantImmediately(variant);
  this.updateStickyATCFromVariantImmediately(variant);

  this.productForm?.toggleSubmitButton(
    !variant.available,
    variant.available
      ? window.variantStrings.addToCart
      : window.variantStrings.soldOut
  );

  document.dispatchEvent(
    new CustomEvent("variant:change", {
      detail: {
        variant,
        sectionId: this.sectionId,
      },
    })
  );
    return variant;
}
updateMediaFromVariantImmediately(variant) {
  if (!variant) return;

  const gallery = this.querySelector("media-gallery");
  if (!gallery) return;

  const image =
    variant.featured_image ||
    variant.image ||
    variant.featured_media?.preview_image;

  const mediaId =
    variant.featured_media?.id ||
    variant.featured_image?.id ||
    variant.image?.id;

  if (mediaId) {
    gallery.setActiveMedia?.(`${this.dataset.section}-${mediaId}`, false);
    gallery.setActiveMedia?.(`${this.sectionId}-${mediaId}`, false);
    return;
  }

  const src = image?.src || image;
  if (!src) return;

  const cleanFile = String(src).split("?")[0].split("/").pop();
  if (!cleanFile) return;

  const matchedImage = Array.from(
    this.querySelectorAll("media-gallery li[data-media-id] img")
  ).find((img) => {
    return (
      String(img.currentSrc || img.src).includes(cleanFile) ||
      String(img.src).includes(cleanFile)
    );
  });

  const mediaItem = matchedImage?.closest("li[data-media-id]");
  if (mediaItem?.dataset?.mediaId) {
    gallery.setActiveMedia?.(mediaItem.dataset.mediaId, false);
  }
}

updateStickyATCFromVariantImmediately(variant) {
  if (!variant) return;

  const options =
    variant.options ||
    [variant.option1, variant.option2, variant.option3].filter(Boolean);

  document
    .querySelectorAll(".sticky-atc-active-variant")
    .forEach((group) => {
      const valueEls = group.querySelectorAll(
        ".sticky-atc-active-variant__option-value"
      );

      valueEls.forEach((el, index) => {
        if (options[index] == null) return;
        el.textContent =
          String(options[index]) + (index < options.length - 1 ? " /" : "");
      });
    });

  const image =
    variant.featured_image ||
    variant.image ||
    variant.featured_media?.preview_image;

  const src = image?.src || image;

  if (src) {
    document
      .querySelectorAll(
        "#selectedVariantImage-mobile, #selectedVariantImage-desktop"
      )
      .forEach((img) => {
        img.src = src;
        img.alt = image.alt || variant.name || "Selected Variant Image";
      });
  }

  document
    .querySelectorAll(".sticky-atc-button, .sticky-atc-trigger")
    .forEach((button) => {
      const textSpan = button.querySelector("span");

      button.classList.remove("loading");

      if (variant.available) {
        button.disabled = false;
        if (textSpan) {
          textSpan.textContent =
            window.variantStrings?.addToCart || "Add to cart";
        }
      } else {
        button.disabled = true;
        if (textSpan) {
          textSpan.textContent =
            window.variantStrings?.soldOut || "Sold out";
        }
      }
    });
}
      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

     renderProductInfo({ requestUrl, targetId, callback }) {
  const requestId = ++this.latestVariantRequest;

  this.abortController?.abort();
  this.abortController = new AbortController();

  fetch(requestUrl, { signal: this.abortController.signal })
    .then((response) => response.text())
    .then((responseText) => {
      if (requestId !== this.latestVariantRequest) return;

      this.pendingRequestUrl = null;

      const html = new DOMParser().parseFromString(
        responseText,
        "text/html"
      );

      callback(html);
    })
    .then(() => {
      if (requestId !== this.latestVariantRequest) return;

      document.querySelector(`#${targetId}`)?.focus();
    })
    .catch((error) => {
      if (error.name === "AbortError") return;

      console.error(error);
      this.applySelectedVariantImmediately();
    });
}

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-selects [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      updateOptionValues(html) {
  const oldVariantSelects = this.variantSelectors;
  if (!oldVariantSelects) return;

  // Oryndra fix:
  // Do not trust fetched section HTML for checked/selected/unavailable state.
  // Facebook/Insta webview can return stale/default HTML. The live clicked selection is truth.

  oldVariantSelects
    .querySelectorAll('input[type="radio"]')
    .forEach((radio) => {
      radio.classList.remove("disabled", "visually-disabled");
      radio.removeAttribute("disabled");
    });

  oldVariantSelects
    .querySelectorAll("select option")
    .forEach((option) => {
      option.disabled = false;
      option.removeAttribute("disabled");
    });

  oldVariantSelects
    .querySelectorAll(".label-unavailable")
    .forEach((label) => label.remove());

  const selectedOptions = this.getCurrentSelectedOptionNames();

  oldVariantSelects
    .querySelectorAll("[data-selected-value]")
    .forEach((label, index) => {
      if (selectedOptions[index]) {
        label.textContent = selectedOptions[index];
      }

      label
        .querySelectorAll?.(".label-unavailable")
        ?.forEach((el) => el.remove());
    });

  const variant = this.getVariantFromCurrentOptions();

  const oldVariantJson = oldVariantSelects.querySelector(
    "script[data-selected-variant]"
  );

  if (variant && oldVariantJson) {
    oldVariantJson.textContent = JSON.stringify(variant);
  }
}

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const fetchedVariant = this.getSelectedVariant(html);

this.updateOptionValues(html);

// Oryndra fix: live clicked variant is the source of truth.
// Fetched section HTML can be stale/default in Facebook/Insta webview.
const variant = this.getVariantFromCurrentOptions() || fetchedVariant;

if (!variant) {
  this.applySelectedVariantImmediately();
  return;
}

this.pickupAvailability?.update(variant);
this.updateURL(productUrl, variant.id);
this.updateVariantInputs(variant.id);

          try {
  this.updateMedia(html, variant?.featured_media?.id);
} catch (error) {
  console.error("Oryndra media update fallback:", error);
}

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };

          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) =>
            classList.contains("hidden")
          );
          updateSourceFromDestination(
            "Inventory",
            ({ innerText }) => innerText === ""
          );
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) =>
            classList.contains("hidden")
          );

          this.updateTieredQuantitySelector(html);
          this.updateMediaFromVariantImmediately(variant);
this.updateStickyATCFromVariantImmediately(variant);
          this.updatePromotionalBlockPrices(html);
          this.updateProductSavings(html);
          this.updateQuantityRules(this.sectionId, html);
          
          // Oryndra INP fix: quantity breaks are not used on MIA, so skip this extra update.
          
          this.querySelector(
            `#Quantity-Rules-${this.dataset.section}`
          )?.classList.remove("hidden");
          this.querySelector(
            `#Volume-Note-${this.dataset.section}`
          )?.classList.remove("hidden");

          this.productForm?.toggleSubmitButton(
  !variant?.available,
  variant?.available
    ? window.variantStrings.addToCart
    : window.variantStrings.soldOut
);

          // Dispatch variant change event only once
          if (!this._variantChangeDispatched) {
            document.dispatchEvent(new CustomEvent("variant:change", {
              detail: {
                variant,
                sectionId: this.sectionId
              }
            }));
            this._variantChangeDispatched = true;
            // Reset the flag after a short delay
            setTimeout(() => {
              this._variantChangeDispatched = false;
            }, 100);
          }

          // Update promotional block prices - already called above with html parameter

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
if (!input) return;
input.value = variantId ?? "";
input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector("share-button")?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );

        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(
          true,
          window.variantStrings.unavailable
        );

        const selectors = [
          "price",
          "Inventory",
          "Sku",
          "Price-Per-Item",
          "Volume-Note",
          "Volume",
          "Quantity-Rules",
        ]
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach(({ classList }) => classList.add("hidden"));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover")) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(
            mediaGallerySource.querySelectorAll("li[data-media-id]")
          );
          const sourceSet = new Set(
            mediaGallerySourceItems.map((item) => item.dataset.mediaId)
          );
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [
              item.dataset.mediaId,
              { item, index },
            ])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] =
            refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]")
          );
          const destinationSet = new Set(
            mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId)
          );
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (
              !sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)
            ) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (
              !destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)
            ) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] =
              refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach(
            (destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(
                    `li:nth-of-type(${destinationIndex + 1})`
                  )
                );

                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] =
                  refreshSourceData();
              }
            }
          );
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
  `${this.dataset.section}-${variantFeaturedMediaId}`,
  false
);

        // update media modal
        const modalContent = this.productModal?.querySelector(
          `.product-media-modal__content`
        );
        const newModalContent = html.querySelector(
          `product-modal .product-media-modal__content`
        );
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        const quantityRulesSpinner = this.querySelector(".quantity__rules-cart .loading__spinner");
if (quantityRulesSpinner) quantityRulesSpinner.classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => {
  if (quantityRulesSpinner) quantityRulesSpinner.classList.add("hidden");
});
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(
  `Quantity-Form-${sectionId}`
);

if (!quantityFormUpdated || !this.quantityForm) return;

const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      updateTieredQuantitySelector(html) {
        // Get all tiered-option__prices elements in the current context
        const tieredSelectors = this.querySelectorAll(".tiered-option__prices");
        if (!tieredSelectors || tieredSelectors.length === 0) return;

        // Get all updated tiered-option__prices elements from the new HTML
        const updatedTieredSelectors = html?.querySelectorAll(
          ".tiered-option__prices"
        );
        if (!updatedTieredSelectors || updatedTieredSelectors.length === 0)
          return;

        // Ensure we are only updating the matching number of elements
        tieredSelectors.forEach((tieredSelector, index) => {
          if (updatedTieredSelectors[index]) {
            // Update the inner HTML of the current element
            tieredSelector.innerHTML = updatedTieredSelectors[index].innerHTML;
          }
        });
      }
      updateStickyATC(html) {
        const newStickyATCContainer = html.querySelector(".sticky-atc");
        const currentStickyATCContainer = document.querySelector(".sticky-atc");

        if (newStickyATCContainer && currentStickyATCContainer) {
          const newContent = newStickyATCContainer.innerHTML.trim();

          if (newContent === "") {
            currentStickyATCContainer.classList.add("hidden");
            currentStickyATCContainer.innerHTML = "";
          } else {
            currentStickyATCContainer.classList.remove("hidden");
            currentStickyATCContainer.innerHTML = newContent;
          }
        }
      }
      updatePromotionalBlockPrices(html) {
        const newPromotionalBlockPrices = html.querySelector(".promotional-block");
        const currentPromotionalBlockPrices = document.querySelector(".promotional-block");
        if (newPromotionalBlockPrices && currentPromotionalBlockPrices) {
          // Store the current countdown element
          const currentCountdown = currentPromotionalBlockPrices.querySelector(".promotional-block__countdown");
          
          const newContent = newPromotionalBlockPrices.innerHTML.trim();

          if (newContent === "") {
            currentPromotionalBlockPrices.classList.add("hidden");
            currentPromotionalBlockPrices.innerHTML = "";
          } else {
            currentPromotionalBlockPrices.classList.remove("hidden");
            currentPromotionalBlockPrices.innerHTML = newContent;
            
            // Restore the countdown element if it existed
            if (currentCountdown) {
              const newCountdownSlot = currentPromotionalBlockPrices.querySelector(".promotional-block__countdown");
              if (newCountdownSlot) {
                newCountdownSlot.replaceWith(currentCountdown);
              }
            }
          }
        }
      }

      updateProductSavings(html) {
        const newSavingsContainer = html.querySelector(".product-savings");
        const currentSavingsContainer =
          document.querySelector(".product-savings");

        if (newSavingsContainer && currentSavingsContainer) {
          const newContent = newSavingsContainer.innerHTML.trim();

          if (newContent === "") {
            currentSavingsContainer.classList.add("hidden");
            currentSavingsContainer.innerHTML = "";
          } else {
            currentSavingsContainer.classList.remove("hidden");
            currentSavingsContainer.innerHTML = newContent;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector("variant-selects");
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(
          `quick-order-list[data-id^="${quickOrderListSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

  
    }
  );
}
